/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactPermissions
 */
export interface ContactPermissions {
    /**
     * 
     * @type {boolean}
     * @memberof ContactPermissions
     */
    emailAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactPermissions
     */
    phoneAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactPermissions
     */
    smsAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactPermissions
     */
    whatsappAllowed: boolean;
}

/**
 * Check if a given object implements the ContactPermissions interface.
 */
export function instanceOfContactPermissions(value: object): value is ContactPermissions {
    if (!('emailAllowed' in value) || value['emailAllowed'] === undefined) return false;
    if (!('phoneAllowed' in value) || value['phoneAllowed'] === undefined) return false;
    if (!('smsAllowed' in value) || value['smsAllowed'] === undefined) return false;
    if (!('whatsappAllowed' in value) || value['whatsappAllowed'] === undefined) return false;
    return true;
}

export function ContactPermissionsFromJSON(json: any): ContactPermissions {
    return ContactPermissionsFromJSONTyped(json, false);
}

export function ContactPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPermissions {
    if (json == null) {
        return json;
    }
    return {
        
        'emailAllowed': json['emailAllowed'],
        'phoneAllowed': json['phoneAllowed'],
        'smsAllowed': json['smsAllowed'],
        'whatsappAllowed': json['whatsappAllowed'],
    };
}

export function ContactPermissionsToJSON(json: any): ContactPermissions {
    return ContactPermissionsToJSONTyped(json, false);
}

export function ContactPermissionsToJSONTyped(value?: ContactPermissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailAllowed': value['emailAllowed'],
        'phoneAllowed': value['phoneAllowed'],
        'smsAllowed': value['smsAllowed'],
        'whatsappAllowed': value['whatsappAllowed'],
    };
}

